import { useState, useCallback } from "react";

const STORAGE_KEY = "hf_onboarding_done";

function getDone() {
  try { return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []); }
  catch { return new Set(); }
}

export function useOnboarding(pageKey) {
  const [done, setDone] = useState(getDone);

  const markDone = useCallback((key) => {
    const k = key || pageKey;
    setDone(prev => {
      const next = new Set(prev);
      next.add(k);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify([...next])); } catch {}
      return next;
    });
  }, [pageKey]);

  const isDone = (key) => done.has(key || pageKey);

  return { isDone, markDone };
}
